import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, Sort } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { GeofenceService } from 'src/app/services/geofence.service';
import { first } from 'rxjs/operators';
import { TokenStorage } from 'src/app/util/token.storage';
import { GeofenceAddDialogComponent } from './geofence-add-dialog/geofence-add-dialog.component';
import { GeofenceUpdateDialogComponent } from './geofence-update-dialog/geofence-update-dialog.component';
import { Router } from "@angular/router";
import { GeofenceDetailService } from 'src/app/services/geofencedetail.service';
import { ZoneViewDialogComponent } from './zone-view-dialog/zone-view-dialog.component';
import { GeofenceZoneService } from 'src/app/services/geofencezone.service';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';
import { GeofenceFileUploaderComponent } from './geofence-file-uploader/geofence-file-uploader.component';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import { GeofenceDetailFileUploaderComponent } from './geofence-detail-file-uploader/geofence-detail-file-uploader.component';

@Component({
  selector: 'app-geofence',
  templateUrl: './geofence.component.html',
  styleUrls: ['./geofence.component.scss']
})
export class GeofenceComponent implements OnInit {

  public dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public displayedColumns: string[] = [
    'geofenceId',
    'geofenceName',
    'geofenceDesc',
    'status',
    'geofenceMap',
    'zone',
    'actions'
  ];

  optionsGeofence = {
    fieldSeparator: ',',
    quoteStrings: '',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true,
    headers: ['Geofence ID', 'Geofence Name', 'Geofence Description']
  };

  optionsGeofenceDetails = {
    fieldSeparator: ',',
    quoteStrings: '',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true,
    headers: ['Geofence ID', 'Latitude', 'Longitude', 'Organization ID','Sequence', 'Status']
  };

  public data;
  public tempId;
  public sampleGeofenceData: any;
  public sampleGeofenceDetailData: any;
  allGeofenceIds : any;
  public title: string = WebConstants.MENU_NAMES.GEOFENCE;
  allGeofenceDetails: any;

  constructor(
    public toastrService: ToastrService,
    public router: Router,
    public geofenceService: GeofenceService,
    public geofenceDetailService: GeofenceDetailService,
    public tokenStorage: TokenStorage,
    public geofenceZoneService: GeofenceZoneService,
    public dialog: MatDialog,
    public excelExportDataService: ExcelExportDataService,) { }

  ngOnInit() {
    this.getAllGeofence();
    this.getAllGeofenceDetails();
  }

  getAllGeofence(): void {
    this.geofenceService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.data = response.data;
          console.log(this.data);
          this.dataSource = new MatTableDataSource<unknown>(this.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      });
  }

  getAllGeofenceDetails(): void {
    this.geofenceDetailService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          console.log(response.data);
          this.allGeofenceDetails = response.data;
          this.allGeofenceIds = [...new Set(response.data.map(item => item.geofenceId))];
          var allGeofencesByIds = [];

          for(let i=0; i<this.allGeofenceIds.length; i++){
            var geofence = response.data.filter((geoData)=>{
              return geoData.geofenceId == this.allGeofenceIds[i]
            });

            geofence.sort((a, b) => {
              return a.sequence - b.sequence;
            });
            
            for(let j=0; j<geofence.length; j++){
              geofence[j].lat = parseFloat(geofence[j].lat);
              geofence[j].lng = parseFloat(geofence[j].lng);
            }

            allGeofencesByIds.push(geofence);
          }

          // this.allGeofenceDetails = allGeofencesByIds;
          console.log(this.allGeofenceDetails);
        } 
        else {
          console.log("Geofence Detail API Error!");
        }
      });
  }

  removeGeoFenceDetail(data){
    data.forEach(element => {
      this.DeleteGeoFenceDetail(element.id);
    });    
  }

  DeleteGeoFenceDetail(payload: any){
    this.geofenceDetailService.deleteGeofenceDetail(payload).pipe(first()).subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.router.navigate([WebConstants.WEB_URL.GEOFENCE], {});
      }
    })
  }

  

  deleteGeofenceZoneByGeofenceId(data): void{
    this.geofenceZoneService.deleteGeofenceZoneByGeofenceId(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){

      }
    })
  }

  openMap(element){
    this.router.navigate([WebConstants.WEB_URL.GEOFENCE_DETAIL],{
      queryParams:{
        geofenceId: element.geofenceId,
        geofenceName: element.geofenceName
      },
      skipLocationChange : true
    });
  }

  getTempId(obj: any){
    this.tempId = obj;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteGeofence(geofence: any): void {
    this.geofenceService.deleteGeofenceWithDetails(geofence.geofenceId)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.toastrService.success(response.value, "Geofence Deleted Successfully!");
        this.getAllGeofence();        
      } else {
        this.toastrService.error(response.value, "Failed To Delete Data!")
      }
    });
  }
  

  addGeofenceDialog(): void {
    const dialogRef = this.dialog.open(GeofenceAddDialogComponent, {
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getAllGeofence();
      }      
    });
  }

  updateGeofenceDialog(data: any): void {
    const dialogRef = this.dialog.open(GeofenceUpdateDialogComponent, {
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getAllGeofence();
      }
    });
  }

  viewZoneDialog(data: any): void{
    const dialogRef = this.dialog.open(ZoneViewDialogComponent, {
      data: data,
      disableClose: true
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getAllGeofence();
      }
    });
  }

  exportGeofenceCSV(): void{

    let dataForExcel = [];

    this.data.forEach((row: any) => {
      let rowData = [row.geofenceId, row.geofenceName, row.geofenceDesc]
      dataForExcel.push(rowData);
    });
  
    let reportData = {
      title: "GEOFENCE DATA",
      data: dataForExcel,
      headers: ['Geofence ID', 'Geofence Name', 'Geofence Description']
    };

    this.excelExportDataService.exportExcel(reportData)
  }


  exportGeofenceDetailsCSV(): void{

    let dataForExcel = [];

    this.allGeofenceDetails.forEach((row: any) => {
      let rowData = [row.geofenceId, row.lat, row.lng, row.organizationId, row.sequence, row.status]
      dataForExcel.push(rowData);
    });
  
    let reportData = {
      title: "GEOFENCE DETAILS",
      data: dataForExcel,
      headers: ['Geofence ID', 'Latitude', 'Longitude', 'Organization ID', 'Sequence', 'Status']
    };

    this.excelExportDataService.exportExcel(reportData)
  }


  importGeofenceCSV(): void{

    const dialogRef = this.dialog.open(GeofenceFileUploaderComponent, {
      width: '550px',
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllGeofence();
    });

  }

  importGeofenceDetailsCSV(): void{
    const dialogRef = this.dialog.open(GeofenceDetailFileUploaderComponent, {
      width: '550px',
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllGeofence();
    });
  }

  sampleGeofenceCSV() {

    this.sampleGeofenceData = [
      {
        geofenceId: "29",
        geofenceName: "Pasco Corporation",
        description: "Pasco Corporation",
      },
      {
        geofenceId: "55",
        geofenceName: "Luckyone",
        description: "Luckyone Parking",
      },
      {
        geofenceId: "13",
        geofenceName: "Conure Atlanta",
        description: "Atlanta Office",
      },
    ];

    new AngularCsv(this.sampleGeofenceData, "SampleCSV", this.optionsGeofence);
  }


  sampleGeofenceDetailsCSV() {

    this.sampleGeofenceDetailData = [
      {
        geofenceId: 29,
        lat: 34.06462304,
        lng: -84.16669502,
        organizationId: 1,
        sequence: 1,
        status: 1,
      },
      {
        geofenceId: 29,
        lat: 34.0639742260723,
        lng: -84.1675426025162,
        organizationId: 1,
        sequence: 2,
        status: 1,
      },
      {
        geofenceId: 29,
        lat: 34.0634676140376,
        lng: -84.165160800911,
        organizationId: 1,
        sequence: 3,
        status: 1,
      },
    ];

    new AngularCsv(this.sampleGeofenceDetailData, "SampleCSV", this.optionsGeofenceDetails);
  }

}
